const { InspectorControls } = wp.blockEditor;
const { PanelBody, SelectControl, ToggleControl, TextControl } = wp.components;
import CommonPanel from '../wp-controlers/common-panel';

const Inspector = ({ attributes, setAttributes }) => {
  const { containerized, variant, placeholder, useIn } = attributes;

  return (
    <InspectorControls>
      <PanelBody title="Conteúdo do Bloco" initialOpen={true}>
        <ToggleControl
          label="Este titulo está fora de um container?"
          checked={containerized}
          onChange={() => setAttributes({ containerized: !containerized })}
        />

        <SelectControl
          label="Selecione o estilo desejado"
          title="Selecione o estilo desejado"
          value={variant}
          options={[
            {
              label: 'Default',
              value: 'default',
            },
            {
              label: 'Branco',
              value: 'white',
            },
          ]}
          onChange={(position) => setAttributes({ variant: position })}
        />

        <TextControl
          label="Placeholder"
          value={placeholder}
          onChange={(value) => setAttributes({ placeholder: value })}
        />

        <SelectControl
          label="Esta pesquisa é usada para:"
          title="Esta pesquisa é usada para:"
          value={useIn}
          options={[
            {
              label: 'Accordion',
              value: 'accordion',
            },
            {
              label: 'Tabs com Accordion',
              value: 'accordion-tabs',
            },
            {
              label: 'Cidades',
              value: 'locations',
            },
          ]}
          onChange={(position) => setAttributes({ useIn: position })}
        />
      </PanelBody>

      <CommonPanel attributes={attributes} setAttributes={setAttributes} />
    </InspectorControls>
  );
};

export default Inspector;
